/* eslint-disable camelcase */
import { put, select, delay } from 'redux-saga/effects';
import axios from 'src/api/Api';
import {
    VALIDATE_PRODUCTS_SUCCESS,
    VALIDATE_PRODUCTS_FAILURE,
} from '../actions';
import {
    convertObjectToQueryParams,
    generate_UUID,
    isModifySurgery,
    isTransferSurgery,
    limitQuantityTo50,
} from 'src/utils/util';
import {
    setCartData,
    setSurgeryDetailsGeneric,
} from 'src/pages/scheduleSurgery/redux/actions';
import { TISSUE_AND_NON_TISSUE_SALES_ORG } from 'src/constants/productConstants';
import { errorHandler } from 'src/errorHandler/errorHandler';
import {
    filterProductsWithQuantityGreaterThanZero,
    cumulativeLimitAndThresholdLimitQuantityCalculation,
} from 'src/utils/util';
import { SET_PRODUCT_TO_BE_ADDED } from 'src/pages/more/pages/templates/redux/action/actionTypes';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
const validateResponse = (response) => {
    if (Array.isArray(response)) {
        if (
            response[0]?.statusCode === '11000' ||
            response[0]?.statusCode === '11001'
        )
            return true;
    }
    if (response?.statusCode === '10501') {
        return false;
    }
};

// method which return the promise of the tissue and non-tissue products validation results
const validateTissueAndNonTissueSalesOrgs = (
    { products, orderType },
    soldToAccount,
    isUHOrder,
    isMastOrder,
    countryISOCode,
    physicianId,
    physicianDisplayName,
    accountName,
    templateID,
    salesOrgs
) => {
    const url = `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/products/validateproduct?`;
    // const tissueSalesOrg = [];
    // const nonTissueSalesOrg = [];
    // const otherSalesOrg = [];
    // const otherSalesOrgItems = [];

    const promiseArray = [];
    if (templateID) {
        const urlWithParams = `${url}${convertObjectToQueryParams({
            templateID: templateID,
            salesOrg: salesOrgs.join(','),
            soldToAccount,
            orderType,
            isMastOrder: isMastOrder,
            isTransferSurgery: isTransferSurgery(),
            isModifySurgery: isModifySurgery(),
            physicianId: physicianId,
            physicianName: physicianDisplayName,
            accountName: accountName,
        })}&uhOrder=${isUHOrder ? isUHOrder : false}`;
        const salesOrgPromise = axios
            .get(urlWithParams)
            .then((response) => response.data);
        promiseArray.push(salesOrgPromise);
    } else {
        const groupProductsBySalesOrg = products.reduce((prev, curr) => {
            prev[curr.salesOrg] = prev[curr.salesOrg] || [];
            prev[curr.salesOrg].push(curr.cfn || curr.productCFN);
            return prev;
        }, {});
        // products.forEach((product) => {
        //     if (product.salesOrg === TISSUE_AND_NON_TISSUE_SALES_ORG.tissue)
        //         tissueSalesOrg.push(product.cfn || product.productCFN);
        //     else if (product.salesOrg === TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue)
        //         nonTissueSalesOrg.push(product.cfn || product.productCFN);
        //     else {
        //         otherSalesOrgItems.push(product.cfn || product.productCFN);
        //         otherSalesOrg.push(product.salesOrg);
        //     }
        // });

        Object.keys(groupProductsBySalesOrg).map((salesOrg) => {
            const salesOrgUrl =
                countryISOCode === 'JP' &&
                window.location.pathname !== '/templates'
                    ? `${url}${convertObjectToQueryParams({
                          productCFN: groupProductsBySalesOrg[salesOrg].join(),
                          salesOrg: salesOrg,
                          soldToAccount,
                          orderType,
                          isMastOrder: isMastOrder,
                          isTransferSurgery: isTransferSurgery(),
                          isModifySurgery: isModifySurgery(),
                          physicianId: physicianId,
                          physicianName: physicianDisplayName,
                          accountName: accountName,
                      })}&uhOrder=${isUHOrder ? isUHOrder : false}`
                    : `${url}${convertObjectToQueryParams({
                          productCFN: groupProductsBySalesOrg[salesOrg].join(),
                          salesOrg: salesOrg,
                          soldToAccount,
                          orderType,
                          isMastOrder: isMastOrder,
                      })}&uhOrder=${isUHOrder ? isUHOrder : false}`;
            const salesOrgPromise = axios
                .get(salesOrgUrl)
                .then((response) => response.data);
            promiseArray.push(salesOrgPromise);
        });
    }
    // if (tissueSalesOrg.length > 0) {
    //     const tissueUrl = `${url}${convertObjectToQueryParams({
    //         productCFN: tissueSalesOrg.join(),
    //         salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.tissue,
    //         soldToAccount,
    //         orderType,
    //     })}&uhOrder=${isUHOrder ? isUHOrder : false}`;
    //     const tissuePromise = axios
    //         .get(tissueUrl)
    //         .then((response) => response.data);
    //     promiseArray.push(tissuePromise);
    // }
    // if (nonTissueSalesOrg.length > 0) {
    //     const nonTissueUrl = `${url}${convertObjectToQueryParams({
    //         productCFN: nonTissueSalesOrg.join(),
    //         salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue,
    //         soldToAccount,
    //         orderType,
    //     })}&uhOrder=${isUHOrder ? isUHOrder : false}`;

    //     const nonTissuePromise = axios
    //         .get(nonTissueUrl)
    //         .then((response) => response.data);
    //     promiseArray.push(nonTissuePromise);
    // }
    // if (otherSalesOrgItems.length > 0) {
    //     const nonTissueUrl = `${url}${convertObjectToQueryParams({
    //         productCFN: otherSalesOrgItems.join(),
    //         salesOrg: otherSalesOrg[0],
    //         soldToAccount,
    //         orderType,
    //     })}&uhOrder=${isUHOrder ? isUHOrder : false}`;

    //     const nonTissuePromise = axios
    //         .get(nonTissueUrl)
    //         .then((response) => response.data);
    //     promiseArray.push(nonTissuePromise);
    // }

    return Promise.all(promiseArray);
};

export default function* validateProducts(action) {
    const {
        soldToAccount: soldToAccountFromSurgery,
        inventoryShipping,
        existingProducts,
        moreTemplate,
        productWithIsPlaceHolderSet,
        productWithIsDeleteButtonPresent,
        isUHOrder,
        countryISOCode,
        physicianId,
        physicianDisplayName,
        accountName,
        salesOrgs,
        templateAccounts,
    } = yield select((state) => ({
        soldToAccount:
            state.surgeryReducer.surgeryDetails?.accountId?.accountId,
        inventoryShipping:
            state.surgeryReducer.surgeryDetails.inventoryShipping,
        existingProducts: state.CategoryNameReducer.moreTemplate
            ? [
                  ...(state.commonTemplateReducer.setProducts || []),
                  ...(state.commonTemplateReducer.itemProducts || []),
              ]
                  .filter((p) => !p.isTemplateEntryDeleted)
                  .map((p) => ({
                      ...p,
                      productCFN: p.productCFN || p.cfn,
                      quantity: Number(p.quantity) || 1,
                  }))
            : state.surgeryReducer.cartData.products,
        moreTemplate: state.CategoryNameReducer.moreTemplate,
        productWithIsPlaceHolderSet:
            state.surgeryDetailsReducer.productWithIsPlaceHolderSet,
        productWithIsDeleteButtonPresent:
            state.surgeryDetailsReducer.productWithIsDeleteButtonPresent,
        isUHOrder:
            state.surgeryDetailsReducer?.surgeryData?.surgeryDetails?.isSEorUH,
        countryISOCode: state?.loginReducer?.hybrisUserDetails?.countryISOCode,
        physicianId:
            state?.surgeryReducer?.surgeryDetails?.physicianId?.physicianId,
        physicianDisplayName:
            state?.surgeryReducer?.surgeryDetails?.physicianId
                ?.physicianDisplayName,
        accountName:
            state?.surgeryReducer?.surgeryDetails?.accountId?.accountName,
        salesOrgs: state?.loginReducer?.allSalesOrg || [],
        templateAccounts: state?.commonTemplateReducer?.accounts || [],
    }));
    const soldToAccount = moreTemplate
        ? templateAccounts?.length > 0
            ? templateAccounts[templateAccounts.length - 1]?.accountId
            : undefined
        : soldToAccountFromSurgery;
    const { isMastOrder } = yield select((state) => ({
        isMastOrder: state.loginReducer.isMastOrder,
    }));
    const { isCondensedView } = yield select((state) => ({
        isCondensedView: state.loginReducer.isCondensedView,
    }));
    const { isMastOrderTemplate } = yield select((state) => ({
        isMastOrderTemplate: state.commonTemplateReducer.isMastOrderTemplate,
    }));
    const { searchType, isFromTemplateDetails, isFromSurgery, templateID } =
        action?.payload || {};
    action.payload.isCartProductcheck = action.payload.isCartProductcheck
        ? action.payload.isCartProductcheck
        : false;
    const getProductIdentity = (product) => {
        const cfn = product?.productCFN || product?.cfn || '';
        const salesOrg = product?.salesOrg || '';
        const setType = product?.isSet ? 'set' : 'item';
        return `${cfn}::${salesOrg}::${setType}`;
    };
    // Auto-add (addItemRule) request objects only carry {cfn, quantity, salesOrg}
    // and don't know isSet ahead of validation, so getProductIdentity's setType
    // segment can mismatch against the validated API response. Fall back to
    // matching on CFN + salesOrg only so those items aren't lost (empty productCFN).
    const getProductCFNIdentity = (product) => {
        const cfn = product?.productCFN || product?.cfn || '';
        const salesOrg = product?.salesOrg || '';
        return `${cfn}::${salesOrg}`;
    };
    try {
        let result = [];
        let productWithPlaceHolder = action.payload?.products?.filter(
            (a) => !productWithIsPlaceHolderSet?.some((s) => s.cfn === a.cfn)
        ) || [];
        let productForValidation =
            productWithPlaceHolder?.length > 0
                ? productWithPlaceHolder?.filter((a) =>
                      productWithIsDeleteButtonPresent
                          ?.filter((data) => !data.isSet)
                          .every((s) => s?.cfn !== a?.cfn)
                  )
                : action.payload.products?.filter((a) =>
                      productWithIsDeleteButtonPresent
                          ?.filter((data) => !data.isSet)
                          .every((s) => s?.cfn !== a?.cfn)
                  );
        var results = yield validateTissueAndNonTissueSalesOrgs(
            {
                products:
                    (productWithIsPlaceHolderSet &&
                        productWithIsPlaceHolderSet.length > 0) ||
                    (productWithIsDeleteButtonPresent &&
                        productWithIsDeleteButtonPresent?.filter(
                            (item) => !item.isSet
                        ).length > 0)
                        ? // productForValidation?.length > 0
                          productForValidation
                        : action.payload.products,
                orderType: action.payload.orderType,
            },
            soldToAccount,
            isUHOrder,
            isMastOrder || isMastOrderTemplate,
            countryISOCode,
            physicianId,
            physicianDisplayName,
            accountName,
            templateID,
            salesOrgs
        );
        let totalCount = 0;
        let accountError = null;
        let surgeonError = null;
        // tissue and non-tissue validation results are returned as different entitites,
        //so merging both the results
        // results = [
        //     {
        //         countOfCartProducts: 10,
        //         products: [
        //             {
        //                 brand: 'AFFINITY',
        //                 description: 'AFNT11 TRIAL',
        //                 implantable: false,
        //                 instrument: true,
        //                 isExcluded: false,
        //                 isExcludedExtraItem: false,
        //                 isReservationSet: false,
        //                 isSet: true,
        //                 productCFN: 'SPSJAFTR',
        //                 productFamily: '',
        //                 uom: 'EA',
        //             },
        //             {
        //                 brand: 'TRIMLINE',
        //                 description: 'TRIMLINE ﾚﾄﾗｸﾀｰﾄﾚｰ',
        //                 implantable: false,
        //                 instrument: true,
        //                 isExcluded: false,
        //                 isExcludedExtraItem: false,
        //                 isReservationSet: false,
        //                 isSet: false,
        //                 productCFN: '175-945',
        //                 productFamily: '',
        //                 uom: 'EA',
        //             },
        //         ],
        //         surgeonValidationErrorResponse: [
        //             {
        //                 statusCode: '11001',
        //                 statusDescription:
        //                     'The Account is not approved for the following material(s): ',
        //                 products: [
        //                     'SPSJSVAL - SOVEREIGN ALIF IMPLANT KIT',
        //                     'SPSJSVAL - SOVEREIGN ALIF IMPLANT KIT',
        //                 ],
        //             },
        //             {
        //                 statusCode: '11000',
        //                 statusDescription:
        //                     'The Surgeon is not approved for the following material(s): ',
        //                 products: [
        //                     'SPSJSVAL - SOVEREIGN ALIF IMPLANT KIT',
        //                     'SPSJSVAL - SOVEREIGN ALIF IMPLANT KIT',
        //                 ],
        //             },
        //         ],
        //     },
        // ];
        results.forEach(
            ({
                products = [],
                countOfCartProducts = 0,
                surgeonValidationErrorResponse,
            }) => {
                result = [...result, ...products];
                totalCount += countOfCartProducts;
                accountError = surgeonValidationErrorResponse?.errors?.filter(
                    (msg) => msg?.statusCode === '11001'
                ) || [];
                surgeonError = surgeonValidationErrorResponse?.errors?.filter(
                    (msg) => msg?.statusCode === '11000'
                ) || [];
            }
        );

        //In modify surgery cart data, we are not having the thresholdlimit and comulativelimit
        //So using the same saga to add thresholdlimit and cumulativelimit in modify surgery

        if (action.payload.templateScreen) {
            if (result?.length > 0) {
                yield put({
                    type: VALIDATE_PRODUCTS_SUCCESS,
                    validatedProducts: [],
                    templateProducts: results[0].products,
                });
            }
        } else {
            if (
                result.length === 0 &&
                (accountError?.length > 0 || surgeonError?.length > 0)
            ) {
                yield put({
                    type: VALIDATE_PRODUCTS_SUCCESS,
                    validatedProducts: [],
                    accountError: accountError,
                    surgeonError: surgeonError,
                });
                return;
            } else {
                if (searchType === 'cartProductsValidation') {
                    const clonedProductsCart = JSON.parse(
                        JSON.stringify(existingProducts)
                    );
                    result.forEach((validatedProduct) => {
                        const validatedProductIndex =
                            clonedProductsCart.findIndex(
                                (product) =>
                                    getProductIdentity(product) ===
                                    getProductIdentity(validatedProduct)
                            );
                        if (validatedProductIndex === -1) {
                            return;
                        }
                        const {
                            thresholdLimit,
                            cumulativeLimit,
                            cumulativeLimitPHValue,
                        } = validatedProduct;
                        clonedProductsCart[
                            validatedProductIndex
                        ].thresholdLimit = thresholdLimit;
                        clonedProductsCart[
                            validatedProductIndex
                        ].cumulativeLimit = cumulativeLimit;
                        clonedProductsCart[
                            validatedProductIndex
                        ].cumulativeLimitPHValue = cumulativeLimitPHValue;
                    });
                    yield put(setCartData({ products: clonedProductsCart }));
                    yield put({
                        type: VALIDATE_PRODUCTS_SUCCESS,
                        validatedProducts: [],
                        statusCode: results[0]?.statusCode,
                        statusMessage: results[0]?.statusMessage,
                        isEMEA: results[0]?.isEMEA,
                        orderquantitythreshold:
                            results[0]?.orderquantitythreshold,
                        salesOrg: results[0]?.salesOrg,
                    });
                    yield put(
                        setSurgeryDetailsGeneric({
                            name: 'callCartProductsValidation',
                            value: false,
                        })
                    );

                    return;
                }
                //this will give the summation of quantity of threshold and cumulative limits
                // For copy/edit template flows, existing products loaded from the server may lack
                // cumulativeLimitPHValue / cumulativeLimit / thresholdLimit. Enrich them first
                // using the payload products (client-side metadata) then the API result as fallback.
                const enrichedExistingProducts = moreTemplate
                    ? (() => {
                        const limitsLookup = {};
                        (action.payload.products || []).forEach((p) => {
                            const key = `${p.productCFN || p.cfn || ''}::${p.salesOrg || ''}`;
                            if (p.cumulativeLimitPHValue || p.cumulativeLimit || p.thresholdLimit) {
                                limitsLookup[key] = {
                                    cumulativeLimitPHValue: p.cumulativeLimitPHValue,
                                    cumulativeLimit: p.cumulativeLimit,
                                    thresholdLimit: p.thresholdLimit,
                                };
                            }
                        });
                        result.forEach((r) => {
                            const key = `${r.productCFN || r.cfn || ''}::${r.salesOrg || ''}`;
                            if (!limitsLookup[key] && (r.cumulativeLimitPHValue || r.cumulativeLimit || r.thresholdLimit)) {
                                limitsLookup[key] = {
                                    cumulativeLimitPHValue: r.cumulativeLimitPHValue,
                                    cumulativeLimit: r.cumulativeLimit,
                                    thresholdLimit: r.thresholdLimit,
                                };
                            }
                        });
                        return existingProducts.map((p) => {
                            if (p.cumulativeLimitPHValue || p.cumulativeLimit || p.thresholdLimit) {
                                return p; // already has limit data
                            }
                            const key = `${p.productCFN || p.cfn || ''}::${p.salesOrg || ''}`;
                            return limitsLookup[key] ? { ...p, ...limitsLookup[key] } : p;
                        });
                    })()
                    : existingProducts;
                let {
                    existingItemsWithQuantity,
                    existingCumulativeLimitPHValuesWithQuantity,
                } =
                    cumulativeLimitAndThresholdLimitQuantityCalculation(
                        enrichedExistingProducts
                    );
                const productItemsTobeValidatedBasedOnCumulativeLimit = [];
                //productValidation method will return the validation of the product for excluded,
                //excludedExtraItems, inventoryshipping, thresholld limit
                const productValidation = (product) => {
                    const {
                        isExcluded,
                        isExcludedExtraItem,
                        cumulativeLimit,
                        thresholdLimit,
                        salesOrg,
                        isSet,
                        inventoryShipping,
                        cfn,
                        reservationSetErrorMessage,
                        productCFN,
                    } = product;
                    let isValid = false;
                    let thresholdLimitError = false;
                    let cumulativeLimitError = false;
                    let isB33Item =
                        cfn?.includes('B33') || productCFN?.includes('B33');
                    if (
                        isExcluded ||
                        isExcludedExtraItem ||
                        isB33Item ||
                        reservationSetErrorMessage
                    ) {
                        return {
                            isValid,
                            thresholdLimitError,
                            cumulativeLimitError,
                        };
                    } else if (
                        (inventoryShipping &&
                            salesOrg ===
                                TISSUE_AND_NON_TISSUE_SALES_ORG.tissue) ||
                        (inventoryShipping && !isSet)
                    ) {
                        return {
                            isValid,
                            thresholdLimitError,
                            cumulativeLimitError,
                        };
                    } else if (thresholdLimit || cumulativeLimit) {
                        productItemsTobeValidatedBasedOnCumulativeLimit.push({
                            ...product,
                        });
                    } else {
                        isValid = true;
                        thresholdLimitError = false;
                        cumulativeLimitError = false;
                    }

                    return {
                        isValid,
                        thresholdLimitError,
                        cumulativeLimitError,
                    };
                };

                var { products = [] } = action.payload;
                if (templateID) {
                    if (Array.isArray(results[0]?.products)) {
                        results[0].products.forEach((product) => {
                            const productCFN =
                                product.productCFN || product.cfn;

                            if (!product.isSet) {
                                products.push({
                                    ...product,
                                    cfn: productCFN,
                                    quantity: parseInt(
                                        product.templateEntryQuantity
                                    ),
                                });
                            } else {
                                for (
                                    let qty = 1;
                                    qty <=
                                    parseInt(product.templateEntryQuantity);
                                    qty++
                                ) {
                                    products.push({
                                        ...product,
                                        cfn: productCFN,
                                        quantity: 1,
                                    });
                                }
                            }
                        });
                    }
                }
                var productsForValidation = [];
                // While adding products from product template screen, template might have same product multiple times,
                // so we are increasing the quantity
                // products = [
                //     {
                //         brand: 'BALLAST',
                //         cfn: 'SPSJAFTR',
                //         dailyRate: 'N/A',
                //         description: 'BALLAST CLOSED CN MAS 10.5MM IMPLANT',
                //         isSet: true,
                //         materialType: 'ZLNR',
                //         ph1: 'A30',
                //         ph2: 'A30G66',
                //         ph3: 'A30G66A09',
                //         ph4: 'A30G66A09ACC',
                //         ph5: 'A30G66A09ACCAA2',
                //         salesOrg: 'S024',
                //         uom: 'EA',
                //         quantity: 1,
                //     },
                //     {
                //         brand: 'SOLERA 4.75',
                //         cfn: '175-945',
                //         dailyRate: 'N/A',
                //         description: '4.75-4.75 LATERAL CONNECTOR',
                //         isSet: true,
                //         materialType: 'ZLNR',
                //         ph1: 'A30',
                //         ph2: 'A30G50',
                //         ph3: 'A30G50A09',
                //         ph4: 'A30G50A09ATT',
                //         ph5: 'A30G50A09ATTAF1',
                //         salesOrg: 'S024',
                //         uom: 'EA',
                //         quantity: 1,
                //     },
                // ];
                products.forEach((product) => {
                    const index = productsForValidation.findIndex(
                        (item) =>
                            getProductIdentity(item) ===
                            getProductIdentity(product)
                    );
                    if (index === -1) {
                        productsForValidation.push({
                            ...product,
                            quantity: Number(
                                product.quantity ? product.quantity : 1
                            ),
                        });
                    } else {
                        productsForValidation[index].quantity =
                            productsForValidation[index].quantity +
                            Number(product.quantity);
                    }
                });
                const validatedProducts = result;
                const productsToBeAddedToCart = [];
                let validatedProductIndex = 0;

                // calculating products to be added to cart
                validatedProducts.forEach((validatedProduct) => {
                    validatedProductIndex = productsForValidation.findIndex(
                        (product) =>
                            getProductIdentity(validatedProduct) ===
                            getProductIdentity(product)
                    );
                    if (validatedProductIndex === -1) {
                        validatedProductIndex = productsForValidation.findIndex(
                            (product) =>
                                getProductCFNIdentity(validatedProduct) ===
                                getProductCFNIdentity(product)
                        );
                    }
                    validatedProduct.description = !action?.payload?.addItemRule
                        ? productsForValidation[validatedProductIndex]?.description
                        : validatedProduct?.description;
                    validatedProduct.salesOrg = !action?.payload?.addItemRule
                        ? productsForValidation[validatedProductIndex]?.salesOrg
                        : validatedProduct?.salesOrg;
                    validatedProduct.isSet = !action?.payload?.addItemRule
                        ? productsForValidation[validatedProductIndex]?.isSet
                        : validatedProduct?.isSet;
                    const {
                        isValid,
                        thresholdLimitError,
                        cumulativeLimitError,
                    } = productValidation({
                        ...validatedProduct,
                        ...productsForValidation[validatedProductIndex],
                        inventoryShipping,
                    });

                    validatedProduct.thresholdLimitError = thresholdLimitError;
                    validatedProduct.cumulativeLimitError =
                        cumulativeLimitError;

                    if (isValid) {
                        if (action.payload.addItemRule) {
                            productsForValidation[validatedProductIndex] = {
                                ...productsForValidation[validatedProductIndex],
                                description: validatedProduct?.description,
                                isSet: validatedProduct?.isSet,
                                uom: validatedProduct?.uom,
                            };
                        }
                        productsToBeAddedToCart.push({
                            ...productsForValidation[validatedProductIndex],
                            isReservationSet: validatedProduct.isReservationSet,
                            implantable: validatedProduct.implantable,
                            instrument: validatedProduct.instrument,
                            businessRules:
                                validatedProduct?.businessRules?.length > 0
                                    ? validatedProduct?.businessRules
                                    : [],
                            addItemRules:
                                validatedProduct?.addItemRules?.length > 0
                                    ? validatedProduct?.addItemRules
                                    : [],
                            productMoreDetails:
                                validatedProduct.productMoreDetails,
                            reservationSetErrorMessage:
                                validatedProduct.reservationSetErrorMessage,
                            quantity: productsForValidation[
                                validatedProductIndex
                            ]?.quantity
                                ? productsForValidation[validatedProductIndex]
                                      ?.quantity
                                : 1,
                            isProductFamily:
                                validatedProduct?.productFamily !== '' &&
                                validatedProduct?.productFamily?.split(',')
                                    ?.length > 0
                                    ? true
                                    : false,
                            productFamily:
                                validatedProduct?.productFamily !== '' &&
                                validatedProduct?.productFamily?.split(',')
                                    ?.length > 0
                                    ? validatedProduct?.productFamily?.split(
                                          ','
                                      )
                                    : [],
                            cumulativeLimitPHValue:
                                validatedProduct?.cumulativeLimitPHValue,
                            cumulativeLimit: validatedProduct?.cumulativeLimit,
                            thresholdLimit: validatedProduct?.thresholdLimit,
                        });
                    }
                });
                const itemsWithThresholdLimitError = {};
                // calculating the products that are having cumulative limit or threshold limit error
                productItemsTobeValidatedBasedOnCumulativeLimit.forEach(
                    (product) => {
                        const {
                            cumulativeLimitPHValue,
                            cumulativeLimit,
                            thresholdLimit,
                            productCFN,
                            quantity,
                        } = product;
                        const validatedProductIndexAPIResponse =
                            validatedProducts.findIndex(
                                (validatedItem) =>
                                    getProductIdentity(validatedItem) ===
                                    getProductIdentity(product)
                            );
                        if (validatedProductIndexAPIResponse === -1) {
                            return;
                        }
                        const requestedQuantity = Number(quantity) || 0;
                        validatedProducts[
                            validatedProductIndexAPIResponse
                        ].thresholdLimitError = false;
                        validatedProducts[
                            validatedProductIndexAPIResponse
                        ].cumulativeLimitError = false;
                        const existingQuantityForThreshold =
                            existingItemsWithQuantity[productCFN] &&
                            existingItemsWithQuantity[productCFN]?.quantity
                                ? Number(
                                      existingItemsWithQuantity[productCFN]
                                          ?.quantity
                                  )
                                : 0;
                        const existingCumulativeQuantity =
                            existingCumulativeLimitPHValuesWithQuantity[
                                cumulativeLimitPHValue
                            ] &&
                            existingCumulativeLimitPHValuesWithQuantity[
                                cumulativeLimitPHValue
                            ]?.quantity
                                ? Number(
                                      existingCumulativeLimitPHValuesWithQuantity[
                                          cumulativeLimitPHValue
                                      ]?.quantity
                                  )
                                : 0;
                        const normalizedThresholdLimit =
                            thresholdLimit !== undefined &&
                            thresholdLimit !== null &&
                            thresholdLimit !== ''
                                ? Number(thresholdLimit)
                                : null;
                        const normalizedCumulativeLimit =
                            cumulativeLimit !== undefined &&
                            cumulativeLimit !== null &&
                            cumulativeLimit !== ''
                                ? Number(cumulativeLimit)
                                : null;

                        const hasThresholdLimit = Number.isFinite(
                            normalizedThresholdLimit
                        );
                        const hasCumulativeLimit = Number.isFinite(
                            normalizedCumulativeLimit
                        );

                        const thresholdRemaining = hasThresholdLimit
                            ? Math.max(
                                  normalizedThresholdLimit -
                                      existingQuantityForThreshold,
                                  0
                              )
                            : requestedQuantity;

                        const cumulativeRemaining =
                            hasCumulativeLimit && cumulativeLimitPHValue
                                ? Math.max(
                                      normalizedCumulativeLimit -
                                          existingCumulativeQuantity,
                                      0
                                  )
                                : requestedQuantity;

                        const allowedQuantity = Math.max(
                            Math.min(
                                requestedQuantity,
                                thresholdRemaining,
                                cumulativeRemaining
                            ),
                            0
                        );

                        const isThresholdExceeded =
                            hasThresholdLimit &&
                            existingQuantityForThreshold + requestedQuantity >
                                normalizedThresholdLimit;

                        const isCumulativeExceeded =
                            hasCumulativeLimit &&
                            cumulativeLimitPHValue &&
                            existingCumulativeQuantity + requestedQuantity >
                                normalizedCumulativeLimit;

                        if (isThresholdExceeded) {
                            validatedProducts[
                                validatedProductIndexAPIResponse
                            ].thresholdLimitError = true;
                        }

                        if (isCumulativeExceeded) {
                            validatedProducts[
                                validatedProductIndexAPIResponse
                            ].cumulativeLimitError = true;
                        }

                        // Copy cumulative/threshold metadata so dispatched products
                        // include cumulativeLimitPHValue for grouping in popup logic
                        if (cumulativeLimitPHValue) {
                            validatedProducts[
                                validatedProductIndexAPIResponse
                            ].cumulativeLimitPHValue = cumulativeLimitPHValue;
                        }
                        if (cumulativeLimit !== undefined && cumulativeLimit !== null) {
                            validatedProducts[
                                validatedProductIndexAPIResponse
                            ].cumulativeLimit = cumulativeLimit;
                        }
                        if (thresholdLimit !== undefined && thresholdLimit !== null) {
                            validatedProducts[
                                validatedProductIndexAPIResponse
                            ].thresholdLimit = thresholdLimit;
                        }
                        if (product.salesOrg) {
                            validatedProducts[
                                validatedProductIndexAPIResponse
                            ].salesOrg = product.salesOrg;
                        }
                        if (product.isSet !== undefined) {
                            validatedProducts[
                                validatedProductIndexAPIResponse
                            ].isSet = product.isSet;
                        }
                        if (product.description) {
                            validatedProducts[
                                validatedProductIndexAPIResponse
                            ].description = product.description;
                        }

                        if (cumulativeLimitPHValue) {
                            itemsWithThresholdLimitError[
                                cumulativeLimitPHValue
                            ] = {
                                thresholdLimitError:
                                    validatedProducts[
                                        validatedProductIndexAPIResponse
                                    ].thresholdLimitError ||
                                    itemsWithThresholdLimitError[
                                        cumulativeLimitPHValue
                                    ]?.thresholdLimitError
                                        ? true
                                        : false,
                            };
                        }

                        if (allowedQuantity > 0) {
                            productsToBeAddedToCart.push({
                                ...product,
                                quantity: allowedQuantity,
                                cumulativeLimitError: false,
                                thresholdLimitError: false,
                            });

                            if (hasThresholdLimit) {
                                existingItemsWithQuantity[productCFN] = {
                                    quantity:
                                        existingQuantityForThreshold +
                                        allowedQuantity,
                                };
                            }

                            if (
                                hasCumulativeLimit &&
                                cumulativeLimitPHValue
                            ) {
                                existingCumulativeLimitPHValuesWithQuantity[
                                    cumulativeLimitPHValue
                                ] = {
                                    quantity:
                                        existingCumulativeQuantity +
                                        allowedQuantity,
                                };
                            }
                        }
                    }
                );

                if (
                    action.payload.isSurgeryCopyHydration ||
                    action.payload.isMastCopyHydration
                ) {
                    const findRequestedProduct = (validatedProduct) => {
                        const validatedCFN =
                            validatedProduct.productCFN ||
                            validatedProduct.cfn;
                        return productsForValidation.find((product) => {
                            const productCFN = product.productCFN || product.cfn;
                            return (
                                productCFN === validatedCFN &&
                                (!validatedProduct.salesOrg ||
                                    product.salesOrg ===
                                        validatedProduct.salesOrg) &&
                                (validatedProduct.isSet === undefined ||
                                    product.isSet === validatedProduct.isSet)
                            );
                        });
                    };
                    const validProductIdentities = new Set(
                        validatedProducts
                            .filter(
                                (product) =>
                                    !product.isExcluded &&
                                    !product.isExclude &&
                                    !product.isExcludedItem &&
                                    !product.isExclusionItem &&
                                    !product.isExcludedExtraItem &&
                                    !product.isInvalidItemMsg &&
                                    !product.reservationSetErrorMessage &&
                                    !(
                                        product.productCFN?.includes('B33') ||
                                        product.cfn?.includes('B33')
                                    )
                            )
                            .map((product) => {
                                const requestedProduct =
                                    findRequestedProduct(product) || {};
                                return getProductIdentity({
                                    ...product,
                                    salesOrg:
                                        product.salesOrg ||
                                        requestedProduct.salesOrg,
                                    isSet:
                                        product.isSet !== undefined
                                            ? product.isSet
                                            : requestedProduct.isSet,
                                });
                            })
                    );
                    const copiedCartProducts = yield select(
                        (state) => state.surgeryReducer.cartData.products
                    );
                    const reconciledCopiedProducts = copiedCartProducts.filter(
                        (product) =>
                            validProductIdentities.has(
                                getProductIdentity(product)
                            )
                    );

                    if (
                        reconciledCopiedProducts.length !==
                        copiedCartProducts.length
                    ) {
                        yield put(
                            setCartData({ products: reconciledCopiedProducts })
                        );
                    }
                }

                if (moreTemplate) {
                    if (!isFromTemplateDetails) {
                        yield delay(1500);
                    }
                    yield put({
                        type: VALIDATE_PRODUCTS_SUCCESS,
                        validatedProducts: validatedProducts?.map(
                            (product) => ({
                                ...product,
                                isReservationSet: product?.isReservationSet,
                                implantable: product?.implantable,
                                instrument: product?.instrument,
                                productMoreDetails: product?.productMoreDetails,
                                reservationSetErrorMessage:
                                    product?.reservationSetErrorMessage,
                                businessRules:
                                    product?.businessRules?.length > 0
                                        ? product?.businessRules
                                        : [],
                                addItemRules:
                                    product?.addItemRules?.length > 0
                                        ? product?.addItemRules
                                        : [],

                                productAdded:
                                    productsToBeAddedToCart.length !== 1 &&
                                    !product.isExcluded &&
                                    !product.isExcludedExtraItem &&
                                    moreTemplate
                                        ? false
                                        : searchType === 'productSearch' &&
                                          productsToBeAddedToCart.length === 1,
                                nonInventoryShipping:
                                    !product.isExcludedExtraItem &&
                                    !moreTemplate
                                        ? (inventoryShipping &&
                                              product.salesOrg ===
                                                  TISSUE_AND_NON_TISSUE_SALES_ORG.tissue) ||
                                          (inventoryShipping && !product.isSet)
                                        : false,
                                isB33Item: product.productCFN.includes('B33'),
                                productFamily: result[0].productFamily
                                    ? result[0].productFamily.split(',')
                                    : [],
                                salesOrg: result[0]?.salesOrg,
                                thresholdLimitError: product?.thresholdLimitError,
                                cumulativeLimitError: product?.thresholdLimitError
                                    ? false
                                    : product?.cumulativeLimitError,
                            })
                        ),
                        statusCode: results[0]?.statusCode,
                        statusMessage: results[0]?.statusMessage,
                        isEMEA: results[0]?.isEMEA,
                        orderquantitythreshold:
                            results[0]?.orderquantitythreshold,
                        salesOrg: results[0]?.salesOrg,
                        accountError: accountError,
                        surgeonError: surgeonError,
                        validProductsCount: totalCount,
                    });
                    var data = [];
                    let validatedData = [];
                    validatedData = validatedProducts?.map((product) => ({
                        ...product,
                        isReservationSet: product?.isReservationSet,
                        implantable: product?.implantable,
                        instrument: product?.instrument,
                        productMoreDetails: product?.productMoreDetails,
                        reservationSetErrorMessage:
                            product?.reservationSetErrorMessage,
                        businessRules:
                            product?.businessRules?.length > 0
                                ? product?.businessRules
                                : [],
                        addItemRules:
                            product?.addItemRules?.length > 0
                                ? product?.addItemRules
                                : [],

                        productAdded:
                            productsToBeAddedToCart.length !== 1 &&
                            !product.isExcluded &&
                            !product.isExcludedExtraItem &&
                            moreTemplate
                                ? false
                                : searchType === 'productSearch' &&
                                  productsToBeAddedToCart.length === 1,
                        nonInventoryShipping:
                            !product.isExcludedExtraItem && !moreTemplate
                                ? (inventoryShipping &&
                                      product.salesOrg ===
                                          TISSUE_AND_NON_TISSUE_SALES_ORG.tissue) ||
                                  (inventoryShipping && !product.isSet)
                                : false,
                        isB33Item: product.productCFN.includes('B33'),
                        productFamily: result[0].productFamily
                            ? result[0].productFamily.split(',')
                            : [],
                        thresholdLimitError: product?.thresholdLimitError,
                        cumulativeLimitError: product?.thresholdLimitError
                            ? false
                            : product?.cumulativeLimitError,
                    }));
                    data = action.payload.products?.map((targetItem) => {
                        // Prioritize productsToBeAddedToCart (has allowedQuantity after limit checks)
                        // Fall back to validatedData if product doesn't have limit restrictions
                        const cartItem = productsToBeAddedToCart?.find(
                            (item) =>
                                getProductIdentity(item) ===
                                getProductIdentity(targetItem)
                        );
                        const sourceItem = validatedData?.find(
                            (sourceItem) =>
                                getProductIdentity(sourceItem) ===
                                getProductIdentity(targetItem)
                        );
                        
                        // Use cart item if it exists (has correct allowed quantity), else use validated data
                        const finalSource = cartItem || sourceItem;
                        return finalSource
                            ? {
                                ...targetItem,
                                ...finalSource,
                                quantity: cartItem?.quantity || finalSource?.quantity,
                                implantable: finalSource.implantable,
                                instrument: finalSource.instrument,
                              }
                            : targetItem;
                    });
                    yield put({
                        type: SET_PRODUCT_TO_BE_ADDED,
                        payload: data,
                    });
                }

                // Logic for stopping duplicate entry

                // Create a transaction ID to track this batch of operations
                const operationId = generate_UUID();
                
                // Get the latest existing products to ensure we have the most up-to-date cart
                const latestExistingProducts = yield select((state) => state.surgeryReducer.cartData.products);
                
                // Make a deep clone of the most current cart data
                const clonedExistingProducts = [
                    ...filterProductsWithQuantityGreaterThanZero(
                        latestExistingProducts
                    ),
                ];
                
                // Track processing with timestamps for debugging
                const timestamp = () => new Date().toISOString().substr(11, 12);
                
                // Serialize operations to avoid race conditions between sagas
                yield delay(5); // Small delay to help order operations
                
                // Map of product CFNs to their original objects for reference
                const productMap = {};
                
                productsToBeAddedToCart.forEach((product) => {
                    // Convert quantity to number for safe operations
                    product.quantity = +product?.quantity;
                    
                    // Normalize product CFN
                    product.productCFN = product.productCFN ? product.productCFN : product.cfn;
                    const productIdentity = getProductIdentity(product);
                    productMap[productIdentity] = product;
                    
                    // Find index of product in cart if it exists
                    const productIndex = clonedExistingProducts.findIndex(
                        (item) =>
                            getProductIdentity(item) === productIdentity
                    );
                    
                    // Remove cfn after we've used it for lookup
                    delete product.cfn;
                    
                    // Add flags and requirements
                    if (action.payload.addItemRule === true) {
                        product.isAddItemRuleProduct = true;
                    }
                    if (product.salesOrg !== 'S030')
                        product.shippingRequirement = true;
                    
                    // Handle non-set products by updating quantity
                    if (productIndex !== -1 && !product.isSet) {
                        const currentQuantity = parseInt(clonedExistingProducts[productIndex]?.quantity);
                        const newQuantity = parseInt(product?.quantity);
                        
                        // Safely limit the quantity to maximum of 50
                        const quantity = limitQuantityTo50(currentQuantity + newQuantity);
                        
                        // Update the quantity in the cloned cart
                        clonedExistingProducts[productIndex].quantity = quantity;
                        if (
                            action.payload.addItemRule !== true &&
                            clonedExistingProducts[productIndex]
                                .isAddItemRuleProduct === true
                        ) {
                            clonedExistingProducts[productIndex].userAddedQuantity =
                                (Number(
                                    clonedExistingProducts[productIndex]
                                        .userAddedQuantity
                                ) || 0) + (quantity - currentQuantity);
                        }
                        
                    } 
                    // Add new non-set product
                    else if (productIndex === -1 && !product.isSet) {
                        // Generate a unique product key for new items
                        const newProduct = {
                            ...product,
                            productKey: generate_UUID(),
                        };
                        
                        clonedExistingProducts.push(newProduct);
                    } 
                    // Handle set products (always add as new items with quantity=1)
                    else {
                        // Initialize allocation properties
                        let batchAllocation = {};
                        let transferComplete = false;
                        
                        // Calculate the current quantity of this product in the cart
                        const existingProductQuantity = (clonedExistingProducts?.filter(
                            (item) =>
                                getProductIdentity(item) === productIdentity
                        ) || []).length;
                        
                        // Determine how many new items we can add without exceeding 50
                        const quantityToBeAdded =
                            existingProductQuantity + Number(product?.quantity) > 50
                                ? 50 - existingProductQuantity
                                : Number(product?.quantity);

                        // Add the set product copies with quantity=1
                        for (let i = 1; i <= quantityToBeAdded; i++) {
                            let productModified = {
                                ...product,
                                productKey: generate_UUID(),
                                quantity: 1,
                                batchAllocation,
                                transferComplete,
                                _batchId: operationId,
                                _addedAt: Date.now()
                            };
                            clonedExistingProducts.push(productModified);
                        }
                    }
                });
                
                                if (!action?.payload?.isCartProductcheck) {
                    // Get the latest state one more time to be extra safe
                    const finalLatestProducts = yield select((state) => state.surgeryReducer.cartData.products);
                    
                    // If the cart has changed since we started, we need to be more careful
                    if (JSON.stringify(latestExistingProducts) !== JSON.stringify(finalLatestProducts)) {

                        // Start with the latest cart state
                        const mergedProducts = [...finalLatestProducts];
                        
                        // Process each of our changed products
                        clonedExistingProducts
                            .filter((p) =>
                                p._batchId === operationId ||
                                productMap[getProductIdentity(p)]
                            )
                            .forEach(ourProduct => {
                                const existingIndex = mergedProducts.findIndex(
                                    (p) =>
                                        getProductIdentity(p) ===
                                        getProductIdentity(ourProduct)
                                );
                                
                                if (existingIndex !== -1 && !ourProduct.isSet) {
                                    // For non-set products, update the quantity
                                    mergedProducts[existingIndex].quantity = ourProduct?.quantity;
                                } else {
                                    // For set products or new products, add them
                                    mergedProducts.push(ourProduct);
                                }
                            });
                        
                        // Update the cart with our merged products
                        yield put(setCartData({ products: mergedProducts }));
                    } else {
                        // Standard update when cart hasn't changed
                        yield put(setCartData({ products: clonedExistingProducts }));
                    }
                }

                if (isFromSurgery || isFromTemplateDetails) {
                    yield put({
                        type: VALIDATE_PRODUCTS_SUCCESS,
                        validatedProducts: validatedProducts?.map(
                            (product) => ({
                                ...product,
                                isReservationSet: product?.isReservationSet,
                                implantable: product?.implantable,
                                instrument: product?.instrument,
                                productMoreDetails: product?.productMoreDetails,
                                reservationSetErrorMessage:
                                    product?.reservationSetErrorMessage,
                                businessRules:
                                    product?.businessRules?.length > 0
                                        ? product?.businessRules
                                        : [],
                                addItemRules:
                                    product?.addItemRules?.length > 0
                                        ? product?.addItemRules
                                        : [],
                                productAdded:
                                    productsToBeAddedToCart.length !== 1 &&
                                    moreTemplate &&
                                    !product.isExcluded &&
                                    !product.isExcludedExtraItem
                                        ? true
                                        : searchType === 'productSearch' &&
                                          productsToBeAddedToCart.length === 1,
                                nonInventoryShipping:
                                    !product.isExcludedExtraItem &&
                                    !moreTemplate
                                        ? (inventoryShipping &&
                                              product.salesOrg ===
                                                  TISSUE_AND_NON_TISSUE_SALES_ORG.tissue) ||
                                          (inventoryShipping && !product.isSet)
                                        : false,
                                isB33Item: product.productCFN.includes('B33'),
                                productFamily: result[0].productFamily
                                    ? result[0].productFamily.split(',')
                                    : [],
                                thresholdLimitError: product?.thresholdLimitError,
                                cumulativeLimitError: product?.thresholdLimitError
                                    ? false
                                    : product?.cumulativeLimitError,
                            })
                        ),
                        statusCode: results[0]?.statusCode,
                        statusMessage: results[0]?.statusMessage,
                        isEMEA: results[0]?.isEMEA,
                        orderquantitythreshold:
                            results[0]?.orderquantitythreshold,
                        salesOrg: results[0]?.salesOrg,
                        accountError: accountError,
                        surgeonError: surgeonError,
                        validProductsCount: totalCount,
                    });
                }

                // Added a delay of 1500ms for showing added and tick mark in ui
                // this will re-render the ui with productAdded as false, so tick mark will disapper after 1200ms
                if (
                    searchType === 'productSearch' &&
                    productsToBeAddedToCart.length === 1 //&& (isFromSurgery || (isCondensedView ? !moreTemplate : moreTemplate))
                ) {
                    yield delay(1500);
                    //making the tick mark to be hided
                    yield put({
                        type: VALIDATE_PRODUCTS_SUCCESS,
                        validatedProducts: [
                            {
                                isReservationSet: result[0]?.isReservationSet,
                                businessRules:
                                    result[0]?.businessRules?.length > 0
                                        ? result[0]?.businessRules
                                        : [],
                                addItemRules:
                                    result[0]?.addItemRules?.length > 0
                                        ? result[0]?.addItemRules
                                        : [],
                                implantable: result[0]?.implantable,
                                instrument: result[0]?.instrument,
                                productMoreDetails:
                                    result[0]?.productMoreDetails,
                                reservationSetErrorMessage:
                                    result[0]?.reservationSetErrorMessage,
                                productCFN: result[0].productCFN,
                                productAdded: false,
                                salesOrg: result[0]?.salesOrg,
                                isExcluded: result[0].isExcluded,
                                productFamily: result[0].productFamily
                                    ? result[0].productFamily.split(',')
                                    : [],
                            },
                        ],
                        statusCode: results[0]?.statusCode,
                        statusMessage: results[0]?.statusMessage,
                        isEMEA: results[0]?.isEMEA,
                        orderquantitythreshold:
                            results[0]?.orderquantitythreshold,
                        salesOrg: results[0]?.salesOrg,
                    });
                }
                //  else if (productsToBeAddedToCart.length === 0) {
                //     yield delay(1500);

                //     yield put({
                //         type: VALIDATE_PRODUCTS_SUCCESS,
                //         validatedProducts: [],
                //         statusCode: results[0]?.statusCode,
                //         statusMessage: results[0]?.statusMessage,
                //         isEMEA: results[0]?.isEMEA,
                //         orderquantitythreshold:
                //             results[0]?.orderquantitythreshold,
                //         salesOrg: results[0]?.salesOrg,
                //     });
                // }
            }
        }
    } catch (e) {
// Log error to backend for diagnostics
            yield logUiErrorToBackend(e, {
                apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/products/validateproduct`,
                requestPayload: action?.payload || '',
            });
        yield put({
            type: VALIDATE_PRODUCTS_FAILURE,
            statusCode: errorHandler('503'),
        });
    }
}
